import React, { useState } from "react";
import { SimpleCard } from "@gull";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NotificationManager } from "react-notifications";

import { postLimitBalance } from "app/services/creditService";
import CreditLimitBalanceSheet from "./CreditLimitBalanceSheet";
import DebitLimitBalanceSheet from "./DebitLimitBalancSheet";
import AllMemberAutoComplete from "./AllMemberAutoComplete";
import usePagePermission from "app/hooks/usePagePermission";

const validationSchema = Yup.object().shape({
  memId: Yup.number().required("Please select member"),
  transactionAmount: Yup.number().required("Please enter Transaction Amount"),
  transactionType: Yup.string().required("Please select credit type"),
});

const LimitBalance = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  const [state, setState] = useState({
    memId: "",
    transactionAmount: 0,
    transactionType: "CR",
    dataCount: 0,
  });

  const submitForm = async (values, { resetForm }) => {
    const res = await postLimitBalance(values);
    if (res.status === "Success") {
      NotificationManager.success(res.message);
      resetForm({ values: "" });
    } else {
      NotificationManager.error(res.message);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Limit Balance</title>
      </Helmet>
      <SimpleCard title="Limit Balance" className="mb-4">
        <Formik
          onSubmit={submitForm}
          initialValues={state}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            return (
              <>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={4}>
                      <div className="form-group">
                        <label className="font-weight-bold">Username</label>
                        <span className="text-danger"> *</span>

                        <AllMemberAutoComplete
                          setFieldValue={setFieldValue}
                          memId={state.memId}
                          handleChangeOptions={(memId) => {
                            setFieldValue("memId", memId);
                            setState((prevState) => ({
                              ...prevState,
                              memId,
                            }));
                          }}
                          name="memId"
                          value={values.memId}
                        />
                        {values.balance ? (
                          <b>
                            Wallet Balance : ₹{" "}
                            {Number(values.balance).toFixed(2)}
                          </b>
                        ) : (
                          ""
                        )}
                        {!values.memId ? (
                          <p className="text-danger">{errors.memId}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label className="font-weight-bold">Amount</label>
                        <span className="text-danger"> *</span>

                        <Field
                          type="number"
                          className="form-control w-100"
                          name="transactionAmount"
                          display="Transaction Amount"
                          value={values.transactionAmount}
                        />
                        <div>
                          {errors.transactionAmount &&
                          touched.transactionAmount ? (
                            <p className="text-danger">
                              {errors.transactionAmount}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col lg={4}>
                      <div className="form-group">
                        <label className="font-weight-bold">
                          Transaction Type
                        </label>
                        <span className="text-danger"> *</span>

                        <Field
                          as="select"
                          className="form-control w-100"
                          name="transactionType"
                          display="DR/ CR"
                          value={values.transactionType}
                          onChange={(e) => {
                            setFieldValue("transactionType", e.target.value);
                            setState((prevState) => ({
                              ...prevState,
                              transactionType: e.target.value,
                            }));
                          }}
                        >
                          <option value={"CR"}>Credit</option>
                          <option value={"DR"}>Debit</option>
                        </Field>
                        <div>
                          {errors.transactionType && touched.transactionType ? (
                            <p className="text-danger">
                              {errors.transactionType}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="form-group">
                    {canAdd && (
                      <button className="btn btn-sm btn-primary" type="submit">
                        Submit
                      </button>
                    )}
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
      </SimpleCard>

      <ul className="nav nav-tabs" role="tablist">
        <li className="nav-item">
          <a
            className="nav-link active"
            href="#profile"
            role="tab"
            data-bs-toggle="tab"
          >
            Credit Limit Balance
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#buzz" role="tab" data-bs-toggle="tab">
            Debit Limit Balance
          </a>
        </li>
        <li className="nav-item" style={{ marginLeft: "59%" }}></li>
      </ul>

      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active" id="profile">
          <CreditLimitBalanceSheet creditType={state.creditType} />
        </div>
        <div role="tabpanel" className="tab-pane fade" id="buzz">
          <DebitLimitBalanceSheet creditType={state.creditType} />
        </div>
      </div>
    </div>
  );
};

export default LimitBalance;
